module.exports = __webpack_public_path__ + "img/2.7265e0a8.png";